import { render } from "./maihaowangHome.vue?vue&type=template&id=1204809e&scoped=true"
import script from "./maihaowangHome.vue?vue&type=script&lang=js"
export * from "./maihaowangHome.vue?vue&type=script&lang=js"

import "./maihaowangHome.vue?vue&type=style&index=0&id=1204809e&scoped=true&lang=css"

import exportComponent from "/Users/liusx/Projects/pc-web-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1204809e"]])

export default __exports__